/* eslint-disable import/prefer-default-export */
export const TRIAL_MOCK_IDS = {
  ORGANIZATION_ID: 'trial-org-001',
  BRANCH_ID: 'trial-branch-001',
  BRANCH_NAME: 'Main Branch',
  USER_ID: 'trial-user-001',
  ORG_NAME: 'Acme Academy'
} as const;
